import type { PostureResult, RegimeResult } from '@prm/shared';
import { POSTURE_LABELS } from '@prm/shared';

/**
 * All four posture components, always — never the composite alone. A +2 built
 * from breadth and credit is a different situation from a +2 built from trend and
 * term structure, and collapsing them hides which measurement to distrust.
 */
export function PostureCard({ posture, regime }: { posture: PostureResult; regime: RegimeResult }) {
  return (
    <div className="posture">
      <div className="posture__head">
        <span className="lbl">Market posture</span>
        <span className="posture__composite">
          {posture.composite > 0 ? '+' : ''}
          {posture.composite}/4
        </span>
      </div>

      {posture.components.map((c) => (
        <div className="posture__row" key={c.id} title={`${c.summary}\n\n${c.readings.map((r) => `${r.label}: ${r.value}`).join('\n')}`}>
          <span className={`vote vote--${c.vote > 0 ? 'up' : c.vote < 0 ? 'down' : 'flat'}`}>
            {c.vote > 0 ? '+1' : c.vote < 0 ? '−1' : '0'}
          </span>
          <span className="posture__label">{c.label}</span>
          <span className="posture__readings">
            {c.unavailable
              ? 'unavailable'
              : c.readings
                  .filter((r) => r.value !== '—')
                  .slice(0, 3)
                  .map((r) => r.value)
                  .join(' · ')}
          </span>
        </div>
      ))}

      <div className="posture__band note">
        {posture.band.explanation}
        {regime.postureBand !== null && !regime.postureBandBinding ? (
          <>
            {' '}
            Advisory only — breach is measured against {regime.baseBand.min.toFixed(2)}–
            {regime.baseBand.max.toFixed(2)}×.
          </>
        ) : null}
      </div>

      <div className="footnote">
        Posture: <strong>{POSTURE_LABELS[posture.posture]}</strong>. {posture.verdict}
      </div>
    </div>
  );
}

